import { useEffect } from "react";
import { LegalPage, LegalSection } from "@/components/LegalPage";

export default function Disclaimer() {
  useEffect(() => {
    document.title = "Disclaimer | WanneerKaartverkoop.nl";
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalPage
      testid="disclaimer-page"
      eyebrow="Disclaimer"
      title="Disclaimer"
      intro="Laatst bijgewerkt: oktober 2026."
    >
      <LegalSection title="Verkoopdata onder voorbehoud">
        <p>
          De kaartverkoop- en pre-sale-data op WanneerKaartverkoop.nl zijn afkomstig van
          organisatoren en openbare bronnen, en worden zowel redactioneel als automatisch
          bijgehouden. Organisatoren kunnen data en tijden op elk moment wijzigen. Controleer de
          definitieve informatie altijd op de website van de organisator of het officiële
          verkoopkanaal.
        </p>
      </LegalSection>
      <LegalSection title="Wij zijn geen ticketverkoper">
        <p>
          WanneerKaartverkoop.nl verkoopt zelf geen tickets en is geen partij bij je aankoop. De
          koopknoppen op deze site verwijzen naar de officiële kanalen van de organisator of
          erkende ticketplatforms. Vragen over bestellingen, betalingen of doorverkoop horen daar
          thuis.
        </p>
      </LegalSection>
      <LegalSection title="Externe links">
        <p>
          Waar we naar websites van derden linken, zijn wij niet verantwoordelijk voor de inhoud of
          het privacybeleid van die websites.
        </p>
      </LegalSection>
      <LegalSection title="Aansprakelijkheid">
        <p>
          We doen ons best alle informatie actueel en correct te houden, maar kunnen niet
          aansprakelijk worden gesteld voor gemiste kaartverkopen of schade als gevolg van
          onjuiste, verlate of gewijzigde informatie.
        </p>
      </LegalSection>
      <LegalSection title="Fout gevonden?">
        <p>
          Laat het ons weten via de <a href="/contact" className="text-blaze hover:underline">contactpagina</a>{" "}
          of mail <a href="mailto:info@wanneerkaartverkoop.nl" className="text-blaze hover:underline">info@wanneerkaartverkoop.nl</a>{" "}
          — dan passen we het zo snel mogelijk aan.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
